<template>
  <div v-if="showPrompt" class="install-prompt">
    <div class="install-content">
      <div class="install-icon-container">
        <img src="/img/icons2/icon-128x128.png" alt="app icon" class="install-icon" />
      </div>
      <div class="install-text">
        <p class="install-title">{{ $t('installAppTitle') }}</p>
        <p class="install-message">{{ $t('installAppMessage') }}</p>
      </div>
      <div class="install-buttons">
        <button @click="dismissPrompt" class="install-dismiss-btn">
          {{ $t('later') }}
        </button>
        <button @click="installApp" class="install-btn">
          {{ $t('install') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstallPrompt',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    deferredPrompt: {
      default: null,
      validator: function(value) {
        // Accept null or any object (including BeforeInstallPromptEvent)
        return value === null || (typeof value === 'object' && value !== null)
      }
    }
  },
  data() {
    return {
      showPrompt: false
    }
  },
  watch: {
    show(newVal) {
      this.showPrompt = newVal
    }
  },
  methods: {
    async installApp() {
      if (!this.deferredPrompt) {
        return
      }

      // Show the install prompt
      this.deferredPrompt.prompt()

      // Wait for the user to respond to the prompt
      const { outcome } = await this.deferredPrompt.userChoice

      console.log(`User response to the install prompt: ${outcome}`)

      // Clear the deferredPrompt so it can only be used once
      this.$emit('prompt-used')
      this.showPrompt = false

      // Hide the install prompt UI
      this.deferredPrompt = null
    },
    dismissPrompt() {
      this.showPrompt = false
      this.$emit('dismissed')
    }
  },
  mounted() {
    this.showPrompt = this.show
  }
}
</script>

<style scoped>
.install-prompt {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 10000;
  animation: slideUp 0.3s ease-out;
  max-width: 400px;
  margin: 0 auto;
  direction: rtl;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.install-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.install-icon-container {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.install-icon {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  border: 1px solid rgb(209, 213, 219);
}

.install-text {
  text-align: center;
}

.install-title {
  font-size: 18px;
  font-weight: bold;
  color: #1c274c;
  margin: 0 0 8px 0;
}

.install-message {
  font-size: 14px;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

.install-buttons {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.install-btn {
  flex: 1;
  background: #1c39bb;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  /* box-shadow: 0 2px 8px rgba(28, 57, 187, 0.3); */
}

.install-btn:hover {
  background: #15309a;
  transform: translateY(-2px);
  /* box-shadow: 0 4px 12px rgba(28, 57, 187, 0.4); */
}

.install-btn:active {
  transform: translateY(0);
}

.install-dismiss-btn {
  flex: 1;
  background: #f1f5f9;
  color: #64748b;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.install-dismiss-btn:hover {
  background: #e2e8f0;
}

/* Mobile responsive */
@media (max-width: 480px) {
  .install-prompt {
    bottom: 10px;
    left: 10px;
    right: 10px;
  }

  .install-content {
    padding: 16px;
  }

  .install-icon {
    width: 56px;
    height: 56px;
  }

  .install-title {
    font-size: 16px;
  }

  .install-message {
    font-size: 13px;
  }

  .install-buttons {
    flex-direction: column;
  }

  .install-btn,
  .install-dismiss-btn {
    width: 100%;
  }
}
</style>

